import { useQueries, UseQueryOptions } from "@tanstack/react-query";
import {
  getInvoiceStatusData,
  getOrderStatusData,
  getShipmentStatusData,
  getQuoteRequestStatusData,
} from "api/services/user";
import { userQueryKeys } from "./userQueryKeys";

import {
  flattenData,
  IStatus,
  formatString,
} from "../../../pages/common/Dashboardv2/components/common/widgets/StatusWidget/StatusWidgetUtils";

const useStatusWidgetData = (userType: string, userPermissions: any, options: UseQueryOptions = {}) => {
  const permissions = {
    viewQuickRequests: userType === "provider" ? false : userPermissions.quoting?.view_quick_requests,
    viewQuoteRequests: userPermissions.quoting?.view_quote_requests,
    viewShipments: userPermissions.tracking?.view_shipments,
    viewInvoices: userPermissions.invoicing?.view_invoices,
  };

  const queries = useQueries<any>({
    queries: [
      userType === "shipper" && permissions.viewQuickRequests
        ? {
            queryKey: [userQueryKeys.orderStatus],
            queryFn: () => getOrderStatusData().then((res) => res.data),
            staleTime: 300000,
            ...options,
          }
        : undefined,
      permissions.viewQuoteRequests
        ? {
            queryKey: [userQueryKeys.quoteRequestStatus],
            queryFn: () => getQuoteRequestStatusData().then((res) => res.data),
            staleTime: 300000,
            ...options,
          }
        : undefined,
      permissions.viewShipments
        ? {
            queryKey: [userQueryKeys.shipmentStatus],
            queryFn: () => getShipmentStatusData().then((res) => res.data),
            staleTime: 300000,
            ...options,
          }
        : undefined,
      permissions.viewInvoices
        ? {
            queryKey: [userQueryKeys.invoiceStatus],
            queryFn: () => getInvoiceStatusData().then((res) => res.data),
            staleTime: 300000,
            ...options,
          }
        : undefined,
    ].filter(Boolean) as any[],
  });

  const isFetching = queries.some((query) => query.isFetching);
  const isError = queries.some((query) => query.isError);
  const data = queries.map((query) => query.data).filter(Boolean);

  const combinedData = data.map((res: any) => ({
    group_name: formatString(res.group_name),
    statuses: res.statuses.map((statusObj: IStatus) => ({
      ...statusObj,
      status: formatString(statusObj.status),
    })),
  }));

  const flattenedData = flattenData(combinedData || []);

  return { data: flattenedData, isFetching, isError };
};

export default useStatusWidgetData;
